import { INDRAApiService } from '@ibe.services/api.indra.service';
import { HttpClient } from '@angular/common/http';
import { INDRABookingService } from "@ibe.services/booking.indra.service";
import { URL_BOOKING_MARKET, MOCK_STATUS, MOCK_URL_BOOKING_MARKET } from '@ibe.config';
import * as i0 from "@angular/core";
import * as i1 from "./api.indra.service";
import * as i2 from "@angular/common/http";
import * as i3 from "./booking.indra.service";
var INDRALocationService = /** @class */ (function () {
    function INDRALocationService(api, http, bookingService) {
        this.api = api;
        this.http = http;
        this.bookingService = bookingService;
    }
    /** Returns an array of special locations/country
     *  that will be used depending on each countries' rules.
     *	This method will be used in the long run
     *	after updating the other sidebars */
    INDRALocationService.prototype.INDRA_getSpecialCaseLocation = function (countries, flightSegments, flightIdentifier) {
        var _this = this;
        var specialCaseCountries = [];
        flightSegments.forEach(function (flight) {
            flight.listSegment.forEach(function (segment) {
                var segmentDeparture = _this.bookingService.INDRA_getLocation(segment.departureAirport);
                var segmentArrival = _this.bookingService.INDRA_getLocation(segment.arrivalAirport);
                var filteredCountries = countries.filter(function (country) {
                    return country === segmentDeparture.countryCode || country === segmentArrival.countryCode;
                });
                specialCaseCountries = specialCaseCountries.concat(filteredCountries);
            });
        });
        return specialCaseCountries;
    };
    INDRALocationService.prototype.INDRA_setBookingMarket = function (market, defaultLanguage) {
        // If idOperation is present on current URL, do NOT call market
        var urlParams = new URLSearchParams(window.location.search);
        var idOperation = urlParams.get('idOperation');
        if (MOCK_STATUS.BOOKING_MARKET) {
            return this.api.INDRA_get(MOCK_URL_BOOKING_MARKET);
        }
        else {
            if (idOperation && idOperation.length) {
                return this.api.INDRA_post(URL_BOOKING_MARKET, { 'market': market, 'language': defaultLanguage, 'idOperation': idOperation });
            }
            else {
                return this.api.INDRA_post(URL_BOOKING_MARKET, { 'market': market, 'language': defaultLanguage });
            }
        }
    };
    INDRALocationService.ngInjectableDef = i0.defineInjectable({ factory: function INDRALocationService_Factory() { return new INDRALocationService(i0.inject(i1.INDRAApiService), i0.inject(i2.HttpClient), i0.inject(i3.INDRABookingService)); }, token: INDRALocationService, providedIn: "root" });
    return INDRALocationService;
}());
export { INDRALocationService };
